import { serialiseJql } from '@atlassian/jira-business-filters/src/controllers/utils.tsx';
import { createStore, createHook, type StoreActionApi } from '@atlassian/react-sweet-state';
import type { MappedRule, RuleJqlInput } from '../../common/types';

type FormatRules = {
	rowRules: MappedRule[];
	cellRulesByFieldId: { [fieldId: string]: MappedRule[] };
};

type State = FormatRules & {
	issueIdRowRuleMatched: { [issueId: string]: MappedRule };
	rulesJqlInput: RuleJqlInput;
};

type Actions = typeof actions;

const initialState: State = {
	rowRules: [],
	cellRulesByFieldId: {},
	issueIdRowRuleMatched: {},
	rulesJqlInput: {},
};

const actions = {
	setFormatRules:
		(rules: FormatRules) =>
		({ setState }: StoreActionApi<State>) => {
			const newState = {
				...rules,
			};
			setState(newState);
		},
	setRulesForJqlInput:
		(input: RuleJqlInput) =>
		({ setState }: StoreActionApi<State>) => {
			const newState = {
				rulesJqlInput: input,
			};
			setState(newState);
		},
	setMatchedRowRule:
		({ rule, issueId }: { rule: MappedRule; issueId: string }) =>
		({ setState, getState }: StoreActionApi<State>) => {
			const currentState = getState();
			const newState = {
				issueIdRowRuleMatched: {
					...currentState.issueIdRowRuleMatched,
					[issueId]: rule,
				},
			};
			setState(newState);
		},
	removeMatchedRowRule:
		({ ruleId }: { ruleId: string }) =>
		({ setState, getState }: StoreActionApi<State>) => {
			const { issueIdRowRuleMatched } = getState();

			const rowRuleMatched = Object.entries(issueIdRowRuleMatched).filter(
				([, value]) => value.id !== ruleId,
			);
			const newIssueIdRowRuleMatched = Object.fromEntries(rowRuleMatched);
			setState({
				issueIdRowRuleMatched: newIssueIdRowRuleMatched,
			});
		},
};

const Store = createStore<State, Actions>({
	initialState,
	actions,
	name: 'JWMFormatRules',
});

export const useFormatRulesStore = createHook(Store);

const getSerialisedJql = (state: State) => serialiseJql(state.rulesJqlInput);

export const useFormatRulesSerialisedJql = createHook(Store, { selector: getSerialisedJql });
